<template>
  <div id="mikmak-site">
    <HeaderBar></HeaderBar>
    <HeaderComponent></HeaderComponent>
    <AudiencesProductComponent v-if="focusedVertical == 'customer-acquisition'"></AudiencesProductComponent>
    <!-- <AttachFamily></AttachFamily> -->
    <!-- <Partners></Partners> -->
    <Press id="press"></Press>
    <!-- <ContactUs id="contact"></ContactUs> -->
    <FooterBar></FooterBar>
  </div>
</template>

<script>

// import HeaderBar from '../components/HeaderBar'
import HeaderBar from '../components/site/Header/Header'
import HeaderComponent from '../components/AttachVerticalHeaderComponent/AttachVerticalHeaderComponent'
import IntroText from '../components/IntroText'
import AttachFamily from '../components/AttachFamily'
import Partners from '../components/Partners'
import ProductWrapper from '../components/ProductWrapper'
import ContactUs from '../components/ContactUs'
import Press from '../components/site/PressHero/Press'
import FooterBar from '../components/site/Footer/Footer'
import AttachProductComponent from '../components/AttachProductComponents/AttachProductComponent'
import StudiosProductComponent from '../components/AttachProductComponents/StudiosProductComponent'
import AudiencesProductComponent from '../components/AttachProductComponents/AudiencesProductComponent'
import MarketingPartners from '../components/MarketingPartners'

import eventDispatcher from '../events/dispatch'

export default {
  components: {
    HeaderBar,
    HeaderComponent,
    IntroText,
    AttachFamily,
    Partners,
    ProductWrapper,
    Press,
    ContactUs,
    FooterBar,
    AttachProductComponent,
    StudiosProductComponent,
    AudiencesProductComponent,
    MarketingPartners
  },
  data() {
    return {
      attachTitle: 'MikMak Attach',
      // attachSubtitle: 'We should consider if we want the same language here still.',
      attachSubtitle: 'Improving the post-click and swipe-up commerce experience across every social channel and the open web.',
      studiosTitle: 'MikMak Studios',
      studiosSubtitle: 'Full-service production specialized in fun, short-form product videos.'
    }
  },
  mounted() {
    document.addEventListener('touchstart', function(){}, true);
    eventDispatcher('pageView')
  },
  computed: {
    attachProducts() {
      return this.$store.state.attachProducts
    },
    studiosProducts() {
      return this.$store.state.studiosProducts
    },
    focusedVertical() {
      return this.$route.params.vertical
    }
  }
}

</script>



// WEBPACK FOOTER //
// AttachVertical.vue?08074799